import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import { bhutaniCCData } from './bhutaniCCData';
import bhutaniImg from '../../../assets/bhutani/bhutaniMain.webp'
import { ConnectForm } from '../../common/ConnectForm';


const BhutaniCityCenter = () => {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center"
                style={{ backgroundImage: `url('${bhutaniImg}')` }}
            ></div>
            <div class="flex flex-col md:flex-row px-5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4 py-5 sm:py-8 md:py-12 px-4 sm:px-8">
                    <div className="max-w-5xl mx-auto p-6">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Bhutani City Center 32</h2>
                        <p className="text-md text-gray-700 mb-4 text-justify">A state-of-the-art mixed-use commercial project located in the heart of Noida Sector 32.
                            This development is designed to redefine urban retail sophistication and lifestyle experiences. Here are some key
                            details about the project:</p>
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Location and Accessibility</h2>

                        <p className="text-md text-gray-700 mb-4 text-justify"> Prime Location Situated in Sector 32, Noida, the project enjoys excellent connectivity and accessibility. It is
                            approximately 100 meters from the Noida City Center Metro Station, making it easily accessible for both residents
                            and visitors. The project is centrally located, ensuring a steady footfall and positioning it as a lucrative investment
                            opportunity in Noida's flourishing real estate landscape.</p>
                    </div>
                </div>
                <ConnectForm />
            </div>

            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
                {bhutaniCCData.map((data, index) => (
                    <div key={data.id} className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                        <div className="relative">
                            <img
                                src={data.imgUri}
                                alt={data.title}
                                className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                        <div className="px-5 py-3">
                            <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                            <button type="button"
                                onClick={() => navigate(`/${data.route}`)}
                                class="text-green-500 hover:text-white border border-green-500 hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2 text-center my-1.5 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-600">Know More</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default BhutaniCityCenter;